(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["air-purifier-compare"] && !Shopify.designMode) return;
  try {
    
  function initAirCompare(root) {
    var scope = root || document;
    var sections = [];

    if (scope.matches && scope.matches('[data-air-compare-section]')) {
      sections.push(scope);
    }

    scope.querySelectorAll('[data-air-compare-section]').forEach(function (section) {
      sections.push(section);
    });

    sections.forEach(function (section) {
      if (section.dataset.airCompareReady === 'true') return;
      section.dataset.airCompareReady = 'true';

      var dataElement = section.querySelector('[data-air-compare-products]');
      if (!dataElement) return;

      var productData = {};
      try {
        productData = JSON.parse(dataElement.textContent);
      } catch (error) {
        return;
      }

      function escapeHtml(value) {
        return String(value || '-')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function row(label, value) {
        return [
          '<li class="air-compare-card__row">',
          '<span class="air-compare-card__label">' + escapeHtml(label) + '</span>',
          '<span class="air-compare-card__value">' + escapeHtml(value) + '</span>',
          '</li>'
        ].join('');
      }

      function renderProduct(handle, column) {
        var card = section.querySelector('[data-air-compare-card][data-column="' + column + '"]');
        var product = productData[handle];
        if (!card || !product) return;

        var statusClass = product.available ? '' : ' is-unavailable';
        var statusText = product.available ? 'In stock' : 'Check availability';
        var imageHtml = product.image
          ? '<img class="air-compare-card__image" src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
          : '';
        var badgeHtml = product.badge
          ? '<div class="air-compare-card__badge">' + escapeHtml(product.badge) + '</div>'
          : '';

        card.innerHTML = [
          '<div class="air-compare-card__top">',
          imageHtml,
          badgeHtml,
          '<h2 class="air-compare-card__title">' + escapeHtml(product.title) + '</h2>',
          '<div class="air-compare-card__price">' + escapeHtml(product.price) + '</div>',
          '<div class="air-compare-card__status' + statusClass + '">' + statusText + '</div>',
          '</div>',
          '<ul class="air-compare-card__rows">',
          row('Best for', product.bestFor),
          row('Room size', product.roomSize),
          row('Dust & PM2.5 filtration', product.filtration),
          row('Smart control', product.smartControl),
          row('Noise level', product.noise),
          row('Replacement filter', product.replacementFilter),
          '</ul>',
          '<div class="air-compare-card__footer">',
          '<a class="air-compare-card__button" href="' + escapeHtml(product.url) + '">View product</a>',
          '</div>'
        ].join('');
      }

      section.querySelectorAll('[data-air-compare-select]').forEach(function (select) {
        select.addEventListener('change', function () {
          renderProduct(select.value, select.dataset.column);
        });
        renderProduct(select.value, select.dataset.column);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAirCompare(document);
    });
  } else {
    initAirCompare(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAirCompare(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["levoit-manuals-hub"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-manual-hub]').forEach((hub) => {
      if (hub.dataset.manualHubReady === 'true') return;
      hub.dataset.manualHubReady = 'true';
      const form = hub.querySelector('[data-manual-search]');
      const input = hub.querySelector('[data-manual-query]');
      const cards = [...hub.querySelectorAll('[data-manual-card]')];
      const filters = [...hub.querySelectorAll('[data-manual-filter]')];
      const count = hub.querySelector('[data-manual-count]');
      const empty = hub.querySelector('[data-manual-empty]');
      const catalog = hub.querySelector('[id^="ManualCatalog-"]');
      const grid = hub.querySelector('[data-manual-grid]');
      const pagination = hub.querySelector('[data-manual-pagination]');
      let category = 'all';
      const getPerPage = () => {
        if (window.matchMedia('(max-width: 640px)').matches) return 6;
        if (window.matchMedia('(max-width: 920px)').matches) return 8;
        return 9;
      };
      let currentPage = 1;
      let perPage = getPerPage();

      const normalize = (value) => value
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\s_-]+/g, '');

      const pageButton = (label, page, options = {}) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = label;
        button.disabled = Boolean(options.disabled);
        if (options.current) {
          button.classList.add('is-current');
          button.setAttribute('aria-current', 'page');
        }
        button.setAttribute('aria-label', options.ariaLabel || `Page ${page}`);
        button.addEventListener('click', () => {
          currentPage = page;
          update(false);
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        return button;
      };

      const renderPagination = (totalPages) => {
        pagination.replaceChildren();
        pagination.hidden = totalPages <= 1;
        if (totalPages <= 1) return;

        pagination.append(pageButton('←', Math.max(1, currentPage - 1), {
          disabled: currentPage === 1,
          ariaLabel: 'Previous page'
        }));

        const pages = [];
        for (let page = 1; page <= totalPages; page += 1) {
          if (page === 1 || page === totalPages || Math.abs(page - currentPage) <= 1) pages.push(page);
        }
        pages.forEach((page, index) => {
          if (index > 0 && page - pages[index - 1] > 1) {
            const ellipsis = document.createElement('span');
            ellipsis.textContent = '…';
            ellipsis.setAttribute('aria-hidden', 'true');
            pagination.append(ellipsis);
          }
          pagination.append(pageButton(String(page), page, { current: page === currentPage }));
        });

        pagination.append(pageButton('→', Math.min(totalPages, currentPage + 1), {
          disabled: currentPage === totalPages,
          ariaLabel: 'Next page'
        }));
      };

      const update = (resetPage = true) => {
        if (resetPage) currentPage = 1;
        const query = normalize(input.value.trim());
        const matched = cards.filter((card) => (
          (category === 'all' || card.dataset.category === category)
          && (!query || normalize(card.dataset.search).includes(query))
        ));
        const totalPages = Math.max(1, Math.ceil(matched.length / perPage));
        currentPage = Math.min(currentPage, totalPages);
        const start = (currentPage - 1) * perPage;
        const visibleCards = matched.slice(start, start + perPage);
        const currentCards = new Set(visibleCards);

        cards.forEach((card) => {
          card.hidden = !currentCards.has(card);
          card.classList.remove('is-orphan');
        });
        if (window.matchMedia('(max-width: 920px)').matches && visibleCards.length % 2 === 1) {
          visibleCards[visibleCards.length - 1].classList.add('is-orphan');
        }
        count.textContent = String(matched.length);
        empty.classList.toggle('is-visible', matched.length === 0);
        renderPagination(matched.length === 0 ? 0 : totalPages);
      };

      filters.forEach((button) => button.addEventListener('click', () => {
        category = button.dataset.manualFilter;
        filters.forEach((item) => item.classList.toggle('is-active', item === button));
        update(true);
      }));
      input.addEventListener('input', () => update(true));
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        update(true);
        catalog.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      window.addEventListener('resize', () => {
        const nextPerPage = getPerPage();
        if (nextPerPage === perPage) return;
        const firstVisibleIndex = (currentPage - 1) * perPage;
        perPage = nextPerPage;
        currentPage = Math.floor(firstVisibleIndex / perPage) + 1;
        update(false);
      });
      update(true);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
